<template>
  <div>
    <div
      v-if="loadingList"
      class="eu-pa_6 eu-align_center"
    >
      <emd-loader type="_invert"></emd-loader>
    </div>
    <div
      v-else
      class="el-section"
    >
      <div class="emd-container _highlight_header">
        <div class="emd-container__header">
          <h2 class="emd-text _size_section">
            {{ $t('customer.info.title') }}
          </h2>
        </div>
        <div class="emd-container__content">
          <div class="emd-panel">
            <div class="emd-panel__section">
              <div class="emd-panel__block">
                <div class="el-chunk">
                  <h2 class="emd-text _color_default _type_caption">
                    {{ $t('customer.info.general-data') }}
                  </h2>
                </div>
              </div>
              <div class="emd-panel__block">
                <div class="el-chunk">
                  <p class="emd-text _color_subtle _type_label _size_tiny">
                    {{ $t('customer.info.id') }}
                  </p>
                  <span>{{ customer.id || '-' }}</span>
                </div>
                <div class="el-chunk">
                  <p class="emd-text _color_subtle _type_label _size_tiny">
                    {{ $t('customer.info.code') }}
                  </p>
                  <span>{{ customer.code || '-' }}</span>
                </div>
                <div class="el-chunk">
                  <p class="emd-text _color_subtle _type_label _size_tiny">
                    {{ $t('customer.info.name') }}
                  </p>
                  <span data-testid="customer-name">{{
                    customer.name || '-'
                  }}</span>
                </div>
                <div class="el-chunk">
                  <p class="emd-text _color_subtle _type_label _size_tiny">
                    {{ $t('customer.info.document') }}
                  </p>
                  <span>{{ customer.document || '-' }}</span>
                  <span v-if="customer.type && language === 'pt-BR'">
                    - {{ $t('customer.info.person') }}
                    {{ customer.type || '-' }}</span
                  >
                  <span v-if="customer.type && language === 'en-US'">
                    - {{ customer.type || '-' }}
                    {{ $t('customer.info.person') }}
                  </span>
                </div>
                <div class="el-chunk">
                  <p class="emd-text _color_subtle _type_label _size_tiny">
                    {{ $t('customer.info.email') }}
                  </p>
                  <span>{{ customer.email || '-' }}</span>
                </div>
                <div
                  class="el-chunk"
                  v-if="customer.phones && customer.phones.home_phone"
                >
                  <p class="emd-text _type_label _color_subtle _size_tiny">
                    {{ $t('customer.info.phone') }}
                  </p>
                  <span
                    >{{ customer.phones.home_phone.country_code }}
                    {{ customer.phones.home_phone.area_code }}
                    {{ customer.phones.home_phone.number }}</span
                  >
                </div>
                <div
                  class="el-chunk"
                  v-if="customer.phones && customer.phones.mobile_phone"
                >
                  <p class="emd-text _type_label _color_subtle _size_tiny">
                    {{ $t('customer.info.mobile-phone') }}
                  </p>
                  <span
                    >{{ customer.phones.mobile_phone.country_code }}
                    {{ customer.phones.mobile_phone.area_code }}
                    {{ customer.phones.mobile_phone.number }}</span
                  >
                </div>
                <div class="el-chunk">
                  <p class="emd-text _color_subtle _type_label _size_tiny">
                    {{ $t('customer.info.created-at') }}
                  </p>
                  <span>{{
                    customer.created_at | dateFormat('dateAndHour')
                  }}</span>
                </div>
                <div class="el-chunk">
                  <p class="emd-text _color_subtle _type_label _size_tiny">
                    {{ $t('customer.info.updated-at') }}
                  </p>
                  <span>{{
                    customer.updated_at | dateFormat('dateAndHour')
                  }}</span>
                </div>
                <div
                  class="el-chunk"
                  v-if="Object.entries(customer.metadata).length"
                >
                  <p class="emd-text _color_subtle _type_label _size_tiny">
                    {{ $t('customer.info.more-info') }}
                  </p>
                  <pre>{{ customer.metadata }}</pre>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="permissionIsEnabled('customer.addresses:get')"
      class="el-section"
    >
      <div class="emd-container _highlight_header _footer_spaced_sm">
        <div class="emd-container__header">
          <h2 class="emd-text _size_section">
            {{ $t('customer.info.addresses.title') }}
          </h2>
        </div>
        <div
          v-if="loadingList"
          class="eu-pa_6 eu-align_center"
        >
          <emd-loader :type="'_invert'"></emd-loader>
        </div>
        <div
          v-else
          class="emd-table-responsive"
        >
          <Table
            :fields="fields"
            :items="addresses.items"
          ></Table>
          <empty-list
            class="eu-pb_3"
            v-if="!loadingList && showEmptyList()"
          ></empty-list>
        </div>
        <pagination
          v-if="!loadingList"
          :pagination="addresses.pagination"
          :totalShowing="totalItems"
          :type="'list'"
          :action="action"
          :entity="'customerId'"
        ></pagination>
      </div>
    </div>
    <log-links
      v-if="customer"
      :entity="customer"
      :title="$t('log-links.customer')"
    ></log-links>
  </div>
</template>
<script>
import { EmdLoader } from 'emerald-vue/src/components'
import Table from '@/components/project/molecules/Table.vue'
import EmptyList from '@/components/project/globals/EmptyList.vue'
import Pagination from '@/components/project/globals/Pagination.vue'
import LogLinks from '@/components/project/molecules/LogLinks/index.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'CustomerInfo',
  components: {
    EmdLoader,
    EmptyList,
    Table,
    Pagination,
    LogLinks
  },
  data () {
    return {
      customer: null,
      // addresses: null,
      loadingAddresses: true,
      action: 'GET_CUSTOMER_ADDRESSES',
      fields: [
        {
          id: 'id',
          label: 'customer.info.addresses.id',
          type: 'text'
        },
        {
          id: 'line1;street',
          label: 'customer.info.addresses.address',
          type: 'conditional'
        },
        {
          id: 'line2;complement',
          label: 'customer.info.addresses.complement',
          type: 'conditional'
        },
        {
          id: 'city',
          label: 'customer.info.addresses.city',
          type: 'text'
        },
        {
          id: 'state',
          label: 'customer.info.addresses.state',
          type: 'text'
        },
        {
          id: 'zip_code',
          label: 'customer.info.addresses.zipcode',
          type: 'text'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'merchantId',
      'accountId',
      'customersAddresses',
      'pref',
      'loadingCustomersAddress',
      'permissionIsEnabled'
    ]),
    language () {
      return this.pref.language
    },
    params () {
      return {
        merchantId: this.merchantId,
        accountId: this.accountId,
        customerId: this.$route.params.id
      }
    },
    addresses () {
      return this.customersAddresses
    },
    totalItems () {
      return this.addresses.items.length
    },
    loadingList () {
      return this.loadingCustomersAddress
    }
  },
  methods: {
    showEmptyList () {
      return (
        !this.loadingList &&
        this.addresses.pagination &&
        this.addresses.pagination.total_items === 0
      )
    },
    getCustomer () {
      this.$store.dispatch('GET_CUSTOMER', this.params).then(res => {
        this.customer = res
      })
    },
    getAddresses () {
      const query = {
        page: this.$route.query.page || 1
      }
      this.$router.replace({ query: query }).catch(err => err)
      this.$store.dispatch('GET_CUSTOMER_ADDRESSES', this.params)
    }
  },
  created () {
    if (this.$route.params.tab === 'info') {
      this.getCustomer()
      if (this.permissionIsEnabled('customer.addresses:get'))
        this.getAddresses()
    }
  }
}
</script>
